import React, { memo } from "react";

import Animated from "react-native-reanimated";
import FilterRow from "./FilterRow.js";
import ListView from "components/ListView.js";
import { View } from "react-native";
import { mpAll } from "utils/normalise.js";
import { useLocalSearchParams } from "expo-router";
import { useSelector } from "react-redux";

const Filters = ({}) => {
  const allFilters = useSelector((state) => state.FilterReducer.filters || []);
  const selectedFilters = useSelector(
    (state) => state.FilterReducer.selectedFilters
  );
  const parentSelected = useSelector(
    (state) => state.FilterReducer.parentSelected
  );

  const local = useLocalSearchParams();

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <Animated.View style={{ flex: 1, backgroundColor: "white" }}>
        <View
          style={{
            flex: 1,
            backgroundColor: "white",
          }}
        >
          <View
            style={{
              flex: 1,
            }}
          >
            <ListView
              showsVerticalScrollIndicator={false}
              data={[
                Array.isArray(allFilters?.filters) ? allFilters?.filters : [],
              ]?.flat()}
              renderItem={({ item, index }) => {
                const filter = item;
                const tempSelectedFilters = {
                  ...selectedFilters,
                  1: [
                    ...(selectedFilters?.[1] || []),
                    ...(parentSelected || []),
                  ],
                };
                const appliedData = tempSelectedFilters?.[filter?.id] || [];

                if ([4, 6].includes(item?.id)) {
                  return;
                }

                const isClothing =
                  parentSelected?.find((o) =>
                    [4, 3, 13, "13,3", "3,13"].includes(o?.id)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [
                      "Bottoms",
                      "Coats and Jackets",
                      "Denim",
                      "Dresses",
                      "Jumpsuits",
                      "Knitwear",
                      "Loungewear",
                      "Matching Seperates",
                      "Shirts & Tops",
                      "Shorts",
                      "Skirts",
                      "Skorts",
                      "Sleepwear & Loungewear",
                      "Sport",
                      "Suits",
                      "Swimwear and Beachwear",
                      "Tops",
                    ].includes(o?.title)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [1252, "1252"].includes(o?.id)
                  ) ||
                  (Object.keys(selectedFilters).includes("8") &&
                    selectedFilters?.["8"]?.length > 0);

                const isShoes =
                  parentSelected?.find((o) => o?.id == 5) ||
                  selectedFilters?.[1]?.find((o) =>
                    [
                      "Boots",
                      "Espadrilles",
                      "Flat Shoes",
                      "High Heels",
                      "Mules",
                      "Pumps",
                      "Sandals",
                      "Sneakers",
                    ].includes(o?.title)
                  ) ||
                  (Object.keys(selectedFilters).includes("9") &&
                    selectedFilters?.["9"]?.length > 0);

                const isBra =
                  parentSelected?.find((o) => [4].includes(o?.id)) ||
                  selectedFilters?.[1]?.find((o) => [165].includes(o?.id));

                const isOnlyBra =
                  selectedFilters?.[1]?.length == 1 &&
                  selectedFilters?.[1]?.find((o) => [165].includes(o?.id));

                const showNoOtherSizes =
                  parentSelected?.find((o) =>
                    [2, 7, 1, 9, 10, 11, 14].includes(o?.id)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [2, 7, 1, 9, 10, 11].includes(o?.id)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [2, 7, 1, 9, 10].includes(o?.subCategory)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [
                      "19,18,1",
                      "18,19,1",
                      "1,18,19",
                      "19,1,18",
                      "18,1,19",
                      "1,19,18",
                    ].includes(o?.subCategory)
                  ) ||
                  selectedFilters?.[1]?.find((o) =>
                    [
                      "19,18,1",
                      "18,19,1",
                      "1,18,19",
                      "19,1,18",
                      "18,1,19",
                      "1,19,18",
                    ].includes(o?.id)
                  );

                // clothing
                if ([8].includes(item?.id)) {
                  if (
                    isClothing ||
                    (!local?.searchkey?.includes("bra") &&
                      !showNoOtherSizes &&
                      !isOnlyBra &&
                      !isShoes)
                  ) {
                    return (
                      <FilterRow filter={filter} appliedData={appliedData} />
                    );
                  } else {
                    return <></>;
                  }
                }

                // shoes
                if ([9].includes(item?.id)) {
                  if (
                    isShoes ||
                    (!local?.searchkey?.includes("bra") &&
                      !showNoOtherSizes &&
                      !isBra &&
                      !isClothing)
                  ) {
                    return (
                      <FilterRow filter={filter} appliedData={appliedData} />
                    );
                  } else {
                    return <></>;
                  }
                }

                // bra
                if ([10].includes(item?.id)) {
                  if (
                    isBra ||
                    (local?.searchkey?.includes("bra") &&
                      !showNoOtherSizes &&
                      !isShoes &&
                      !isClothing)
                  ) {
                    return (
                      <FilterRow filter={filter} appliedData={appliedData} />
                    );
                  } else {
                    return <></>;
                  }
                }

                return <FilterRow filter={filter} appliedData={appliedData} />;
              }}
              maxToRenderPerBatch={10}
              keyExtractor={(item, index) =>
                `${item?.id?.toString()}_${index}_filter3`
              }
              estimatedItemSize={70}
              scrollEventThrottle={64}
            />
          </View>
        </View>
      </Animated.View>
    </View>
  );
};

export default memo(Filters);
